var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVirtualMeetingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 24,
    rx: 12,
    fill: "#8231EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1127_6567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1865 12.018C12.9556 12.7187 13.9586 13.1071 14.999 13.1071C16.0395 13.1071 17.0424 12.7187 17.8115 12.018",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3115 8.625V9.75",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6865 8.625V9.75",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 13.125V6.9375C8.25 6.63913 8.36853 6.35298 8.5795 6.142C8.79048 5.93103 9.07663 5.8125 9.375 5.8125H20.625C20.9234 5.8125 21.2095 5.93103 21.4205 6.142C21.6315 6.35298 21.75 6.63913 21.75 6.9375V13.125",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56152 15.375C6.56152 15.7444 6.6343 16.1102 6.77568 16.4515C6.91707 16.7927 7.12431 17.1028 7.38555 17.364C7.6468 17.6252 7.95693 17.8323 8.29825 17.9736C8.63956 18.1149 9.00537 18.1876 9.37477 18.1875H20.6248C21.3707 18.1875 22.0861 17.8912 22.6135 17.3637C23.141 16.8363 23.4373 16.1209 23.4373 15.375H6.56152Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1127_6567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(6 3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualMeetingIcon);
export default __webpack_public_path__ + "static/media/virtualMeetingIcon.07faf84fb1e46031f22de476ac100cb9.svg";
export { ForwardRef as ReactComponent };